/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]    {display:-webkit-box;display:flex;width:100%}[_nghost-%COMP%]     .engines-option{align-content:space-evenly;display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;flex-wrap:wrap;height:135px;-webkit-box-pack:flex-top;justify-content:flex-top;margin-top:15px;width:100%;position:relative}[_nghost-%COMP%]     .engines-option mat-checkbox{margin-right:0}@media (max-width:380px){.engines-option[_ngcontent-%COMP%]{flex-wrap:nowrap;height:auto!important}}"];
export { styles as styles };
